import { Component } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatPrefix } from '@angular/material/form-field';

import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ldw-select-edit',
  templateUrl: './select-edit.component.html',
  styleUrls: ['./select-edit.component.css'],
  imports: [ReactiveFormsModule, MatFormField, MatIcon, MatPrefix, MatTooltip, MatSelect, MatOption, TranslatePipe]
})
export class SelectEditComponent extends BaseEdit {
  get valueList(): string[] {
    if (!this.isBound) {
      return [];
    }
    // @ts-ignore value can not be undefined, as we check it with isBound
    return this._vmp.valueList;
  }
}
